// extracted by mini-css-extract-plugin
export default {"container":"orders_container__G8cdQ","tabBadge":"orders_tabBadge__-CJgU"};